import React from "react";
import Quiz from "../../../components/Admin/Quiz";
import Navbar from "../../../components/Navbar";

export default function QuizPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <Quiz />
        </div>
      </section>
    </>
  );
}
